import { useState } from 'react';

interface VideoPlayerProps {
  poster: string;
  title: string;
}

export default function VideoPlayer({ poster, title }: VideoPlayerProps) {
  const [notice, setNotice] = useState(false);

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden border border-background-200/70 bg-background-950">
      <img
        src={poster}
        alt={title}
        title={`${title} 播放器封面`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/30 to-background-950/40" />

      {!notice && (
        <button
          type="button"
          onClick={() => setNotice(true)}
          aria-label="播放（演示）"
          className="absolute inset-0 flex items-center justify-center group"
        >
          <span className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-500 text-background-50 transition-transform duration-300 group-hover:scale-110">
            <i className="ri-play-fill text-3xl md:text-4xl" />
          </span>
        </button>
      )}

      {notice && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 bg-background-950/80 backdrop-blur-sm">
          <span className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-500/15 text-accent-500">
            <i className="ri-movie-2-line text-2xl" />
          </span>
          <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">演示播放器</h3>
          <p className="mt-2 max-w-md text-sm text-foreground-600 leading-relaxed">
            当前为前端演示版本，暂未接入真实视频源，无法进行实际播放。正式上线后将支持高清流畅播放。
          </p>
          <button
            type="button"
            onClick={() => setNotice(false)}
            className="mt-5 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors"
          >
            <i className="ri-check-line text-base" />
            知道了
          </button>
        </div>
      )}

      <div className="absolute bottom-0 left-0 right-0 px-3 md:px-4 py-3 bg-gradient-to-t from-background-950/95 to-transparent">
        <div className="h-1 w-full rounded-full bg-background-700/80 overflow-hidden">
          <div className="h-full w-0 rounded-full bg-accent-500" />
        </div>
        <div className="mt-3 flex items-center gap-3 text-foreground-800">
          <button
            type="button"
            onClick={() => setNotice(true)}
            aria-label="播放"
            className="w-8 h-8 flex items-center justify-center hover:text-accent-500 transition-colors"
          >
            <i className="ri-play-fill text-xl" />
          </button>
          <span className="text-xs tabular-nums">00:00 / --:--</span>
          <div className="ml-auto flex items-center gap-3">
            <span className="w-8 h-8 hidden sm:flex items-center justify-center text-foreground-600">
              <i className="ri-volume-up-line text-lg" />
            </span>
            <span className="w-8 h-8 flex items-center justify-center text-foreground-600">
              <i className="ri-fullscreen-line text-lg" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}